module.exports = __webpack_public_path__ + "img/fondoNY2.1f7ef2f2.jpg";